<template>
  <div>
    <b-modal
      ref="createEmployee"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h3
        class="modal-title"
        style="color: #9A9A9A !important">
        CREATE USER
      </h3>
      <div>
        <j-employee-form
          ref="employeeForm"
          mode="create"
          @data="getData"/>
      </div>
      <br>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn blue m__r--5"
              @click="saveCreateEmployee">
              Submit
            </b-button>
            <b-button
              class="btn gray"
              @click="$router.replace('/administrator')">
              Close
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import jEmployeeForm from '@/views/user-employee/detail/jEmployeeForm';
import { mapActions } from 'vuex';
import jMixEncryption from '@/mixins/jMixEncryption';

export default {
  components: {
    jEmployeeForm,
  },
  mixins: [jMixEncryption],
  data() {
    return {
      employee_data: null,
      title: {
        main_title: 'CREATE EMPLOYEE',
      },
    };
  },
  computed: {
    generateData() {
      const genData = {
        email: this.employee_data.email ? this.employee_data.email : null,
        password: this.employee_data.password ? this.employee_data.password : null,
        first_name: this.employee_data.first_name ? this.employee_data.first_name : null,
        last_name: this.employee_data.last_name ? this.employee_data.last_name : null,
        date_of_birth: this.employee_data.date_of_birth ? this.$moment(this.employee_data.date_of_birth).format('YYYY-MM-DD') : null,
        user_role: this.employee_data.role ? this.employee_data.role.id : null,
        // code: this.employee_data.code ? this.employee_data.code : '',
        // is_payroll_user: this.employee_data.is_payroll_user,
        // employee_status: true,
        // secretary_mode: false,
      };
      return genData;
    },
  },
  mounted() {
    this.$refs.createEmployee.show();
    if (!this.publicKey) {
      this.setKeyPublicRSA();
    }
  },
  methods: {
    ...mapActions('jStoreEmployee', ['createEmployee']),

    getData(data) {
      this.employee_data = data;
    },
    async saveCreateEmployee() {
      this.$refs.employeeForm.save();
      if (this.employee_data !== null && this.publicKey) {
        const encryptedPassword = await this.encryption(this.employee_data.password);
        const payload = {
          ...this.generateData,
          password: encryptedPassword,
        };
        await this.createEmployee(payload);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/user-employee/detail/jEmployeeCreate.vue